import { Route, Routes } from 'react-router-dom';

import { css } from '@emotion/react'
import styled from '@emotion/styled'

// basic routes
import StylistList from '../components/Stylists/StylistList';
import EditStylist from '../components/Stylists/EditStylist';
import ViewStylist from '../components/Stylists/ViewStylist';

const Stylists = () => {
  return (
    <Routes>
      <Route path="/" element={<StylistList />} />
      <Route path="/edit/:id" element={<EditStylist />} />
      <Route path="/edit" element={<EditStylist />} />
      <Route path="/view/:id" element={<ViewStylist />} />
    </Routes>
  )
}

export default Stylists;